// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"bafa3f52","453":"24be2dad"}[chunkId] + ".chunk.js";
};